import { IToothShade } from 'lib/types/projectTypes';
import { ICreateProjectProp } from 'lib/types/props/projectProps';
import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import SelectedTeethList from './SelectedTeethList';
import TeethViewer from './TeethViewer';

interface ProjectIndicationProps extends ICreateProjectProp {
  isMultidie?: number;
  isViewer: boolean;
  selectedTeethIsExpanded: {
    value: object[] | any;
    onChange: (e: any) => void;
    setValue: (value: object[] | any) => void;
  };
  isVaildTeethViewer?: boolean;
  toothShadeList: IToothShade[];
  materialShadeList: IToothShade[];
  indicationInfo: any;
  allIndicationOption: [] | null;
  onDeleteTooth?: (e: any, number: number) => void;
  onToggleTooth?: (value: number) => void;
  onSelectedIndicationChange: (
    number: number,
  ) => (event: ChangeEvent<{}>, expanded: boolean) => void;
  onChangeToothValue?: (value: object | any) => void;
  isProjectCreator: boolean;
}

function ProjectIndication({
  isMultidie,
  isViewer,
  selectedTeethIsExpanded,
  numbering,
  teeth,
  tooth,
  copyData,
  bridge,
  toothSvgRef,
  teethContextActions,
  toothShade,
  toothShadeList,
  materialShadeList,
  scanMode,
  scanModeListCt,
  indicationInfo,
  allIndicationOption,
  isVaildTeethViewer,
  onToggleTooth,
  onChangeToothValue,
  onSelectedIndicationChange,
  onDeleteTooth,
  isProjectCreator,
}: ProjectIndicationProps) {
  return (
    <StyledProjectIndication>
      <div className="projectIndication__teeth_viewer">
        <TeethViewer
          isMultidie={isMultidie}
          isViewer={isViewer}
          numbering={numbering}
          teeth={teeth}
          tooth={tooth}
          bridge={bridge}
          copyData={copyData}
          toothSvgRef={toothSvgRef}
          teethContextActions={teethContextActions}
          toothShade={toothShade}
          toothShadeList={toothShadeList}
          scanMode={scanMode}
          scanModeListCt={scanModeListCt}
          isVaildTeethViewer={isVaildTeethViewer}
          onToggleTooth={onToggleTooth}
          onChangeToothValue={onChangeToothValue}
          isProjectCreator={isProjectCreator}
        />
      </div>
      <div className="projectIndication__teeth_list">
        <SelectedTeethList
          isMultidie={isMultidie}
          isViewer={isViewer}
          numbering={numbering}
          teeth={teeth}
          bridge={bridge}
          selectedTeethIsExpanded={selectedTeethIsExpanded}
          indicationInfo={indicationInfo}
          allIndicationOption={allIndicationOption}
          materialShadeList={materialShadeList}
          onDeleteTooth={onDeleteTooth}
          onSelectedIndicationChange={onSelectedIndicationChange}
        />
      </div>
      {/* <ProjectHistoryListContainer /> */}
    </StyledProjectIndication>
  );
}

const StyledProjectIndication = styled.div<{}>`
  display: flex;
  /* flex-grow: 1; */
  width: 100%;
  height: 100%;
  /* column-gap: 90px; */
  .projectIndication__teeth_viewer {
    /* display: flex; */
    /* margin-left: -90px; */
    /* flex: 1; */
    /* width: 100%; */
    width: 440px;
    margin-right: 90px;
    /* padding: 0 60px; */
    /* background-color: green; */
  }
  .projectIndication__teeth_list {
    /* display: flex; */
    flex: 1;
    width: 100%;
    height: 100%;
    width: 480px;
    /* padding-left: 30px; */
    /* margin-left: 30px; */
    /* background-color: yellow; */
  }
`;

export default ProjectIndication;
